module.exports = __webpack_public_path__ + "static/img/blog-details.d0037ff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/blog/blog-details.jpg
// module id = 49OC
// module chunks = 36